import React, { useEffect, useState } from 'react';
import ScreeningAlerts from './ScreeningAlerts';
import { ApiSanctionAlert, sanctionAlertsApi } from '../../apis';

interface Props {
  transactionId: string;
}

export const TransactionScreeningAlerts = ({ transactionId }: Props) => {
  const [fetchingScreeningAlerts, setFetchingScreeningAlerts] = useState(true);
  const [screeningAlerts, setScreeningAlerts] = useState<ApiSanctionAlert[]>();
  const [failedToLoad, setFailedToLoad] = useState(false);

  useEffect(() => {
    sanctionAlertsApi
      .findScreeningAlertsByTransactionId({ transactionId: transactionId })
      .then((alerts) => {
        setFailedToLoad(false);
        setScreeningAlerts(alerts.alerts);
      })
      .catch(() => {
        setFailedToLoad(true);
      })
      .finally(() => setFetchingScreeningAlerts(false));
  }, [transactionId]);

  return (
    <ScreeningAlerts
      page={0}
      size={screeningAlerts?.length || 0}
      total={screeningAlerts?.length || 0}
      alerts={screeningAlerts || []}
      loading={fetchingScreeningAlerts}
      expandable={false}
      failedToLoad={failedToLoad}
    />
  );
};

export default TransactionScreeningAlerts;
